<template>
  <el-dialog
    :visible.sync="modelVisible"
    :footer="false"
    width="580px"
    :show-close="false"
    append-to-body
    :close-on-click-modal="false"
    :close-on-press-escape="false">
    <template #title>
      <div class="dialog-title">
        <div class="dialog-title_desc">
          Submit
        </div>
        <closeIcon @click="handleCloseDialog"/>
      </div>
    </template>
    <div class="reconfirm">
      <div class="reconfirm-tips">
        <div class="reconfirm-tips_icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="rgba(230, 0, 57, 1)">
            <path d="M0 0h48v48H0z" fill="none"/>
            <path d="M2 42h44L24 4 2 42zm24-6h-4v-4h4v4zm0-8h-4v-8h4v8z"/>
          </svg>
        </div>
        <div class="reconfirm-tips_desc">
          The main contact will serve as the administrator account for the
          partner. Please double-check that the email address is correct, as it
          cannot be modified after submission!
        </div>
      </div>
      <div class="reconfirm-content">
        <div class="reconfirm-content_item">
          <div class="reconfirm-content_title">Name</div>
          <div class="reconfirm-content_desc">
            {{ getValue(mainContact, 'firstName') }} {{ getValue(mainContact, 'lastName') }}
          </div>
        </div>

        <div class="reconfirm-content_item">
          <div class="reconfirm-content_title">Job Title</div>
          <div class="reconfirm-content_desc">
            <!-- {{ mainContact.position }} -->
            {{ getValue(mainContact, 'position') }}
          </div>
        </div>

        <div class="reconfirm-content_item">
          <div class="reconfirm-content_title">Work Email</div>
          <div class="reconfirm-content_desc">
            <!-- {{ mainContact.email }} -->
            {{ getValue(mainContact, 'email') }}
          </div>
        </div>

        <div class="reconfirm-content_item">
          <div class="reconfirm-content_title">Office Phone</div>
          <div class="reconfirm-content_desc">
            {{ officePhone }}
          </div>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button v-if="isShowCancelRequest" @click="$emit('cancelRequest')">Cancel</el-button>
      <el-button :loading="loading" @click="modelVisible = false">Back</el-button>
      <el-button :loading="loading" type="primary" @click="$emit('confirm')">Confirm</el-button>
    </span>
  </el-dialog>
</template>

<script>
import CloseIcon from "./closeIcon.vue";

export default {
  name: "enterpriseNetworkReconfirm",
  components: {CloseIcon},
  emits: ["confirm", "update:visible", 'cancelRequest'],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    isShowCancelRequest: {
      type: Boolean,
      default: false
    },
    mainContact: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      modelVisible: false
    };
  },
  computed: {
    officePhone() {
      if (this.getValue(this.mainContact, 'countryCode') && this.getValue(this.mainContact, 'telephone')) {
        if (this.getValue(this.mainContact, 'stateNumber') && this.getValue(this.mainContact, 'extension')) {
          return `+${this.getValue(this.mainContact, 'countryCode')} (${this.getValue(this.mainContact, 'stateNumber')}) ${this.getValue(this.mainContact, 'telephone')} ext.${this.getValue(this.mainContact, 'extension')}`;
        } else if (this.getValue(this.mainContact, 'stateNumber')) {
          return `+${this.getValue(this.mainContact, 'countryCode')} (${this.getValue(this.mainContact, 'stateNumber')}) ${this.getValue(this.mainContact, 'telephone')}`;
        } else if (this.getValue(this.mainContact, 'extension')) {
          return `+${this.getValue(this.mainContact, 'countryCode')} ${this.getValue(this.mainContact, 'telephone')} ext.${this.getValue(this.mainContact, 'extension')}`;
        } else {
          return `+${this.getValue(this.mainContact, 'countryCode')} ${this.getValue(this.mainContact, 'telephone')}`;
        }
      }
      return '-'
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(visible) {
        this.modelVisible = visible;
      }
    },
    modelVisible(visible) {
      this.$emit("update:visible", visible);
    }
  },
  methods: {
    handleCloseDialog() {
      if (this.loading) {
        return
      }
      this.modelVisible = false
    },
    getValue(target, fields) {
      if(!target) {
        return "-"
      }
      return target[fields]
    }
  }
};
</script>
<style scoped lang="less">
.reconfirm-content {
  padding-top: 10px;
  padding-left: 27px;
}

.reconfirm-content_item {
  margin-bottom: 20px;
}

.reconfirm-content_title {
  color: #808080;
}

.reconfirm-content_desc {
  color: #2b2b2b;
}

/deep/ .el-dialog__header {
  padding: 0 18px 0 20px;
  border-bottom: 1px solid #e1e4e7 !important;
}

/deep/ .el-dialog__body {
  padding: 18px;
}

/deep/ .el-dialog__footer {
  border-top: 1px solid #e1e4e7;
  padding: 20px;

  .el-button {
    width: 120px;
    height: 42px;
    font-size: 16px;
  }
}

.dialog-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
}

.dialog-title_desc {
  font-size: 18px;
  color: #808080;
}

.reconfirm-tips {
  display: flex;
  gap: 9px;
  align-items: flex-start;
}

.reconfirm-tips svg {
  width: 18px;
  height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/views/enterpriseNetwork/components/reconfirm.vue